import React from 'react';
import { formatLeadTime } from "../utils/formatters";
import QuantityInput from './QuantityInput';

const ItemModal = ({ 
  show, 
  onClose, 
  item,
  theme,
  onAddToCart,
  onViewCart,
  getCartItemQuantity,
  updateCartQuantity,
  handleRemoveFromCart,
  zIndex = 9999,
}) => {
  const inCart = item && getCartItemQuantity(item.store_items_id) > 0;
  const isVariablePricing = item?.price_type?.toLowerCase() === "variable";
  
  return (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: show ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex,
  }}>
    <div style={{
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '600px',
      width: '90%',
      color: 'black',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '90vh',
      overflow: 'hidden',
    }}>
      <h3 style={{ marginTop: 0, textAlign: 'center' }}>{item?.title || ''}</h3>
      <div style={{ 
        marginBottom: '20px',
        overflowY: 'auto',
        overflowX: 'hidden',
        flex: 1,
      }}>
        <div style={{ textAlign: 'left' }}>
          {/* Main title with larger font */}
          <h3 style={{ 
            fontSize: '1.5em',
            fontWeight: '600',
            marginBottom: '24px',
            color: '#2c3e50',
            borderBottom: '2px solid ' + theme.primaryFontColor,
            paddingBottom: '12px'
          }}>{item?.title || ''}</h3>

          {/* Description Section */}
          <div style={{ marginBottom: '32px' }}>
            <h4 style={{ 
              fontSize: '1.1em', 
              marginBottom: '16px',
              color: '#2c3e50',
              fontWeight: '600'
            }}>Product Description</h4>
            <p style={{ 
              marginBottom: '20px',
              lineHeight: '1.5',
              color: '#4a5568'
            }}>{item?.description || 'N/A'}</p>
            
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: '8px 24px',
              alignItems: 'baseline'
            }}>
              <span style={{ color: '#4a5568', fontWeight: '600' }}>Category:</span>
              <span>{item?.category || 'N/A'}</span>
              <span style={{ color: '#4a5568', fontWeight: '600' }}>Subcategory:</span>
              <span>{item?.subcategory || 'N/A'}</span>
            </div>
          </div>

          {/* Divider */}
          <div style={{
            height: '1px',
            backgroundColor: '#e2e8f0',
            margin: '0 0 32px',
          }} />

          {/* Specifications Section */}
          <div style={{ marginBottom: '32px' }}>
            <h4 style={{ 
              fontSize: '1.1em', 
              marginBottom: '16px',
              color: '#2c3e50',
              fontWeight: '600'
            }}>Product Specifications</h4>
            
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '12px',
              alignItems: 'start',
              width: '100%'
            }}>
              {/* Left column */}
              <div style={{ 
                display: 'grid',
                gridTemplateColumns: '150px 1fr',
                gap: '12px',
                alignItems: 'baseline',
                minWidth: 0  // Prevent grid item from expanding beyond container
              }}>
                <span style={{ color: '#4a5568', fontWeight: '600' }}>SKU:</span>
                <span>{item?.sku || 'N/A'}</span>
                
                <span style={{ color: '#4a5568', fontWeight: '600' }}>Lead Time:</span>
                <span>{formatLeadTime(item?.lead_time_hours)}</span>
              </div>

              {/* Right column */}
              <div style={{ 
                display: 'grid',
                gridTemplateColumns: '150px 1fr',
                gap: '12px',
                alignItems: 'baseline',
                minWidth: 0  // Prevent grid item from expanding beyond container
              }}>
                <span style={{ color: '#4a5568', fontWeight: '600' }}>Quantity Available:</span>
                <span>{item?.quantity || 'N/A'}</span>
                
                <span style={{ color: '#4a5568', fontWeight: '600' }}>Price:</span>
                <span style={{ fontSize: '1.1em', fontWeight: '600' }}>{
                  isVariablePricing 
                    ? "Variable" 
                    : `$${item?.retail_price ? Number(item.retail_price.replace(/,/g, "")).toFixed(2) : "N/A"}`
                }</span>
              </div>
            </div>
          </div>

          {/* Cart Section */}
          {inCart && (
            <div style={{ 
              marginTop: '24px',
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <span style={{ fontWeight: '600', color: '#4a5568' }}>Quantity in Cart:</span>
              <QuantityInput
                value={getCartItemQuantity(item?.store_items_id)}
                onBlur={(numVal) => {
                  updateCartQuantity(item?.store_items_id, numVal);
                }}
                onRemove={() => {
                  handleRemoveFromCart(item?.store_items_id);
                }}
                theme={theme}
                className="quantity-input"
                style={{ 
                  padding: '6px 10px',
                  borderRadius: '4px',
                  border: '1px solid #ced4da',
                  width: '80px'
                }}
              />
            </div>
          )}
        </div>
      </div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'flex-end',
        gap: '10px',
        borderTop: '1px solid #eee',
        paddingTop: '20px',
      }}>
        <button 
          onClick={onClose}
          style={{
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer',
            minWidth: '100px',
          }}
        >
          Close
        </button>
        {!isVariablePricing && (
          <button 
            onClick={inCart ? onViewCart : () => onAddToCart(item)}
            style={{
              backgroundColor: theme.accentColor,
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              minWidth: '100px',
            }}
          >
            {inCart ? 'View Cart' : 'Add to Cart'}
          </button>
        )}
      </div>
    </div>
  </div>
  );
};

export default ItemModal;
